import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { TranslateService } from '@ngx-translate/core';
import { ReminderDistributionItem } from '../../../../../services/reminder-analytics/reminder-analytics.model';

@Component({
    selector: 'app-reminder-status-chart',
    templateUrl: './reminder-status-chart.component.html',
    styleUrls: ['./reminder-status-chart.component.scss'],
})
export class ReminderStatusChartComponent implements OnChanges {
    @Input() data: ReminderDistributionItem[] = [];

    chartData: ChartConfiguration<'doughnut'>['data'] = { labels: [], datasets: [] };
    chartOptions: ChartConfiguration<'doughnut'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: 'right', labels: { boxWidth: 12, padding: 12, font: { family: "'Montserrat', sans-serif", size: 12 } } },
        },
        cutout: '60%',
    };

    private statusColors: Record<string, string> = { sent: '#10b981', pending: '#f59e0b', failed: '#ef4444', processing: '#06b6d4' };

    constructor(private translate: TranslateService) {}

    ngOnChanges(): void {
        if (!this.data || this.data.length === 0) return;
        this.chartData = {
            labels: this.data.map((d) => this.translate.instant('pages.collections.analytics.reminder_status_' + d.label)),
            datasets: [
                {
                    data: this.data.map((d) => d.count),
                    backgroundColor: this.data.map((d) => this.statusColors[d.label] || '#6b7280'),
                    borderWidth: 2,
                    borderColor: '#ffffff',
                },
            ],
        };
    }
}
